import React from 'react';
import { useTranslation } from 'react-i18next';
import BulletList from './BulletList';
import CoachVerdictBadge from './CoachVerdictBadge';

const verdictKey = (verdict) => {
  const map = {
    OK: 'OK',
    'En forme': 'En-forme',
    'Sur-intensité': 'Sur-intensite',
    'Sous-charge': 'Sous-charge',
    'Risque blessure': 'Risque-blessure',
    'Données insuffisantes': 'Donnees-insuffisantes'
  };
  return map[verdict] || null;
};

export default function CoachSummaryCard({ coachAnalysis }) {
  const { t } = useTranslation();
  const summary = coachAnalysis?.summary;
  if (!summary) return null;

  const verdict = summary.verdict;
  const key = verdictKey(verdict);
  const verdictLabel = key ? t(`workout.verdict.${key}`) : verdict;

  return (
    <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-xs font-extrabold uppercase tracking-wide text-indigo-800">
            {t('workout.debrief_summary_title')}
          </div>
          <div className="mt-2">
            <CoachVerdictBadge verdict={verdict} label={verdictLabel} />
          </div>
        </div>
        {typeof coachAnalysis?.confidence === 'number' ? (
          <div className="text-[11px] text-indigo-700 font-mono">
            {t('workout.confidence')}: {(coachAnalysis.confidence * 100).toFixed(0)}%
          </div>
        ) : null}
      </div>

      {summary.one_key_focus_next ? (
        <div className="mt-4">
          <div className="text-xs font-bold text-indigo-900">{t('workout.one_key_focus_next')}</div>
          <div className="text-sm text-indigo-900 mt-1">{summary.one_key_focus_next}</div>
        </div>
      ) : null}

      <div className="mt-4 grid md:grid-cols-2 gap-4">
        <div>
          <div className="text-xs font-bold text-gray-600 uppercase tracking-wide">
            {t('workout.good_job')}
          </div>
          <BulletList items={summary.good_job} className="mt-2" />
        </div>
        <div>
          <div className="text-xs font-bold text-gray-600 uppercase tracking-wide">
            {t('workout.attention_points')}
          </div>
          <BulletList items={summary.attention_points} className="mt-2" />
        </div>
      </div>
    </div>
  );
}


